import TaxRateCaptureSettingForm from './TaxRateCaptureSettingForm';

export default TaxRateCaptureSettingForm;
